import React from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, Typography, Divider, Autocomplete, MenuItem } from '@mui/material';
import { illnessMapping, spineOptionsTypes } from '../constants/options';

const MedicalIllnessSection = ({ formData, handleChange, setFormData }) => {
  return (
    <>
      <Typography variant="h6">Medical Illness</Typography>
      
      <h5>CVS</h5>
      {illnessMapping.cvs.map((illness, index) => (
        <FormControlLabel
          key={index}
          control={<Checkbox checked={formData[illness.key] || false} onChange={handleChange(illness.key)} />}
          label={illness.name}
        />
      ))}
      <TextField label="Others" fullWidth value={formData.cvs_others || ''} onChange={handleChange("cvs_others")} />
      <Divider sx={{ my: 2 }} />

      <h5>RS</h5>
      {illnessMapping.rs.map((illness, index) => (
        <FormControlLabel
          key={index}
          control={<Checkbox checked={formData[illness.key] || false} onChange={handleChange(illness.key)} />}
          label={illness.name}
        />
      ))}
      <TextField label="Others" fullWidth value={formData.rs_others || ''} onChange={handleChange("rs_others")} />
      <Divider sx={{ my: 2 }} />

      <h5>GIT</h5>
      {illnessMapping.git.map((illness, index) => (
        <FormControlLabel
          key={index}
          control={<Checkbox checked={formData[illness.key] || false} onChange={handleChange(illness.key)} />}
          label={illness.name}
        />
      ))}
      <TextField label="Others" fullWidth value={formData.git_others || ''} onChange={handleChange("git_others")} />
      <Divider sx={{ my: 2 }} />

      <h5>GNS</h5>
      {illnessMapping.gns.map((illness, index) => (
        <FormControlLabel
          key={index}
          control={<Checkbox checked={formData[illness.key] || false} onChange={handleChange(illness.key)} />}
          label={illness.name}
        />
      ))}
      <Divider sx={{ my: 2 }} />

      <Typography>Spine</Typography>
      <Autocomplete
        freeSolo
        options={spineOptionsTypes}
        value={formData.spine || ''}
        onInputChange={(event, newValue) => setFormData(prev => ({ ...prev, spine: newValue }))}
        renderInput={(params) => <TextField {...params} label="Spine" fullWidth variant="outlined" />}
      />
      <Divider sx={{ my: 2 }} />

      <h5>ENDOCRINE:</h5>
      <FormControlLabel
        control={<Checkbox checked={formData.endocrine_dm || false} onChange={handleChange("endocrine_dm")} />}
        label="Diabetes Mellitus"
      />
      <TextField
        fullWidth
        label="Thyroid"
        value={formData.endocrine_thyroid || ''}
        onChange={handleChange("endocrine_thyroid")}
        select
      >
        <MenuItem value="Hypo">Hypo</MenuItem>
        <MenuItem value="Hyper">Hyper</MenuItem>
      </TextField>
      <TextField fullWidth label="Others" value={formData.endocrine_others || ''} onChange={handleChange("endocrine_others")} sx={{ mt: 2 }} />
      <Divider sx={{ my: 2 }} />

      <h5>GU SYSTEM</h5>
      <FormControlLabel
        control={<Checkbox checked={formData.gu_system_burns || false} onChange={handleChange("gu_system_burns")} />}
        label="Burns"
      />
      <TextField fullWidth label="Others" value={formData.gu_system_others || ''} onChange={handleChange("gu_system_others")} sx={{ mt: 2 }} />
      <Divider sx={{ my: 2 }} />

      <Typography variant="h6">Past/Current Medications</Typography>
      <TextField 
        fullWidth 
        label="PAST/CURRENT MEDICATIONS" 
        value={formData.past_or_current_medications || ''} 
        onChange={handleChange("past_or_current_medications")} 
        multiline 
        rows={3} 
        sx={{ mt: 2 }}
      />
    </>
  );
};

export default MedicalIllnessSection;
